import { adsBuyingSettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, } from 'app.constants';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
export class AdsBuyingController {
    static $inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2', 'AuthenticationService', 'SegmentService'];
    constructor(LoadingService, TranslateService, application, AccountService2, AuthenticationService, SegmentService) {
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.AccountService2 = AccountService2;
        this.AuthenticationService = AuthenticationService;
        this.SegmentService = SegmentService;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.settingsSource = adsBuyingSettingsSource;
    }
    async $onInit() {
        const account = await this.AccountService2.me();
        const userToken = this.AuthenticationService.token;
        const userEmail = encodeURIComponent(account.email);
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.language = this.TranslateService.getCurrentLanguage();
        this.ownerIdentity = useDelegation ? `${userEmail}/${this.application.shortName}` : this.application.shortName;
        this.token = useDelegation ? userToken : this.application.accessKey;
        this.botName = this.application.name;
        this.channelsActive = this.application.isSubflow ? '' : await this.SegmentService.getActiveChannels(this.application);
        this.template = this.application.template;
        this.cluster = this.application.cluster;
        this.plan = this.application.plan;
        this.authEmail = this.AuthenticationService.email;
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.LoadingService.stopLoading();
        this.userPermissionModel = this.application.applicationUserPermissionModel;
    }
}
AdsBuyingController.$inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2', 'AuthenticationService', 'SegmentService'];
